export const AURDAL = "aurdal";
